import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import About from "../pages/About";
import DownloadCatalogue from "../pages/DownloadCatalogue";
import Catalogue from "../pages/Catalogue";
import NewCreation from "../pages/NewCreation";
import CadCam from "../pages/CadCam";
import Register from "../pages/Register";
import Contact from "../pages/Contact";
import Login from "../pages/Login";
import NewsDetail from "../pages/NewsDetail";
import News from "../pages/News";
import SiteLayout from "../components/common/SiteLayout";

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Scroll to the very top on route change
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [pathname]);

    return null;
}

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route element={<SiteLayout />}>
                    <Route path="/" element={<DownloadCatalogue />} />
                    <Route path="/index.html" element={<DownloadCatalogue />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/AboutUs.html" element={<About />} />
                    <Route path="/AboutUs.aspx" element={<About />} />
                    <Route path="/download" element={<DownloadCatalogue />} />
                    <Route path="/catalogue" element={<Catalogue />} />
                    <Route path="/catalouge" element={<Navigate to="/catalogue" replace />} />
                    <Route path="/rawcast" element={<NewCreation />} />
                    <Route path="/RawCast.html" element={<NewCreation />} />
                    <Route path="/rawcast.html" element={<NewCreation />} />
                    <Route path="/raw-cast-:page.html" element={<NewCreation />} />
                    <Route path="/cadcam" element={<CadCam />} />
                    <Route path="/CadCam.html" element={<CadCam />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/Registration.html" element={<Register />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/ContactUs.html" element={<Contact />} />
                    <Route path="/ContactUs.aspx" element={<Contact />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/NewsDetail.html" element={<News />} />
                    <Route path="/NewsDetail-:legacyId.html" element={<News />} />
                    <Route path="/news/:slug" element={<NewsDetail />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
